<template>

    <div class="block-loader" :class="loading > 0 ? 'show' : ''">
        <div class="loader">Loading...</div>
    </div>

</template>

<script>
import { mapGetters } from 'vuex'

export default {
    computed: mapGetters({
        loading: 'loading/loading',
    }),
}
</script>

<style scoped>
.block-loader.show {
    display: block;
}
.block-loader {
    left: 0;
    z-index: 99997;
    overflow: auto;
    position: fixed;
    top: 0;
    height: 100%;
    width: 100%;
    display: none;
    background-color: rgb(238 238 238 / 84%);
    backdrop-filter: blur(2px);
}
.loader,
.loader:before,
.loader:after {
    background: #475279;
    -webkit-animation: load1 1s infinite ease-in-out;
    animation: load1 1s infinite ease-in-out;
    width: 1em;
    height: 4em;
    border-radius: 4px;
}
.loader {
    color: #475279;
    text-indent: -9999em;
    margin: 88px auto;
    position: absolute;
    z-index: 99998;
    font-size: 11px;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-animation-delay: -0.16s;
    animation-delay: -0.16s;
    left: 0;
    right: 0;
    top: 30%;
}
.loader:before,
.loader:after {
    position: absolute;
    top: 0;
    content: '';
}
.loader:before {
    left: -1.5em;
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
}
.loader:after {
    left: 1.5em;
}
@-webkit-keyframes load1 {
    0%,
    80%,
    100% {
        box-shadow: 0 0;
        height: 4em;
    }
    40% {
        box-shadow: 0 -2em;
        height: 5em;
    }
}
@keyframes load1 {
    0%,
    80%,
    100% {
        box-shadow: 0 0;
        height: 4em;
    }
    40% {
        box-shadow: 0 -2em;
        height: 5em;
    }
}

</style>
